// extracted by mini-css-extract-plugin
export default {"card":"RX-z","carouselContainer":"SX-z","carouselContent":"TX-z"};